import { render, staticRenderFns } from "./NotLoggedInLayout.vue?vue&type=template&id=3c1047e2"
import script from "./NotLoggedInLayout.vue?vue&type=script&lang=ts"
export * from "./NotLoggedInLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports